import {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {format} from 'date-fns';

import {useQuestionSampleSetDetail} from './useQuestionSampleSetDetail';
import {getEvaluationScore} from '../AiSupport.utils';

export const QuestionSampleSetDetail = ({
  questionSampleSetId,
}: {
  questionSampleSetId: string;
}) => {
  const {
    isLoading,
    error: fetchError,
    data,
    fetchData,
  } = useQuestionSampleSetDetail({id: questionSampleSetId});

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (fetchError) {
    return (
      <div role="alert" className="alert alert-error my-4">
        <span>{fetchError.message}</span>
      </div>
    );
  }

  if (isLoading || !data) {
    return (
      <div className="flex flex-col items-center justify-center p-10">
        <span className="loading loading-dots loading-lg"></span>
        <p>Loading</p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="flex flex-col gap-2">
        <h4 className="text-3xl">{data.sample.label}</h4>
        <h5 className="font-semibold">
          {format(data.sample.created_at, 'dd MMM yyyy HH:mm')}
        </h5>
        <div>
          <div>
            <span className="font-semibold">Sample Size: </span>
            <span>{data.sample.question_ids.length}</span>
          </div>
        </div>
        <div>
          <Link
            className="btn btn-primary"
            to={`/ai-support/question-sample-sets/${data.sample.id}/data`}>
            Browse Data
          </Link>
        </div>
      </div>

      <div className="my-8">
        <h5 className="text-xl font-bold mb-2">Question Sample Evaluations</h5>
        <div className="my-2">
          <Link
            className="btn btn-primary"
            to={`/ai-support/question-sample-sets/${data.sample.id}/evaluate`}>
            Evaluate Sample
          </Link>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>User</th>
              <th>Date</th>
              <th>Score</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.questionMatchingEvaluationResponses.map(evaluation => (
              <tr key={evaluation.id}>
                <td>
                  <div>{evaluation.user_email}</div>
                  <div className="text-xs">{evaluation.user_id}</div>
                </td>
                <td>{format(evaluation.created_at, 'dd MMM yyyy HH:mm')}</td>
                <td>{getEvaluationScore(evaluation.response)}</td>
                <td>
                  <Link
                    className="btn"
                    to={`/ai-support/question-sample-sets/${data.sample.id}/evaluate/${evaluation.id}`}>
                    View
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
